import EmptyState from '@/components/empty-state';
import PageHeader from '@/components/page-header';
import { Card, CardContent } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatDateTime } from '@/lib/format';
import { admin_account_path } from '@/rails/routes';
import { Link } from '@inertiajs/react';

interface Claim {
  id: string;
  note: string | null;
  createdAt: string;
  app: { id: string; name: string; slug: string };
  company: { id: string; name: string };
  requestedBy: { name: string; emailAddress: string } | null;
}

interface Props {
  claims: Claim[];
}

const Index = ({ claims }: Props) => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Handoffs"
        description="Studio owners who asked to take over their app's database and file storage. Contact each owner and arrange the handoff."
      />

      <Card className="py-2">
        <CardContent className="px-2">
          {claims.length === 0 ? (
            <EmptyState
              className="px-4"
              title="No handoff requests."
              description="A request shows here when a Studio owner asks for one on the Developer page."
            />
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Company</TableHead>
                  <TableHead>App</TableHead>
                  <TableHead>Requested by</TableHead>
                  <TableHead>Note</TableHead>
                  <TableHead>Requested</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {claims.map((claim) => (
                  <TableRow key={claim.id}>
                    <TableCell className="font-medium">
                      <Link
                        href={admin_account_path(claim.company.id)}
                        className="underline-offset-4 hover:underline"
                      >
                        {claim.company.name}
                      </Link>
                    </TableCell>
                    <TableCell>
                      <div>{claim.app.name}</div>
                      <div className="text-muted-foreground text-xs">{claim.app.slug}</div>
                    </TableCell>
                    <TableCell>
                      {claim.requestedBy ? (
                        <>
                          <div>{claim.requestedBy.name}</div>
                          <a
                            href={`mailto:${claim.requestedBy.emailAddress}`}
                            className="text-muted-foreground text-xs underline-offset-4 hover:underline"
                          >
                            {claim.requestedBy.emailAddress}
                          </a>
                        </>
                      ) : (
                        <span className="text-muted-foreground">Unknown</span>
                      )}
                    </TableCell>
                    <TableCell className="max-w-sm whitespace-normal">
                      {claim.note || <span className="text-muted-foreground">No note</span>}
                    </TableCell>
                    <TableCell className="whitespace-nowrap">
                      {formatDateTime(claim.createdAt)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Index;
